import { Logo, MomentoLogo } from '@icons';
import { SwitchLocale } from '@components';
import { useMediaQueries } from '@hooks';
import { useTranslation } from 'next-i18next';
import classnames from 'classnames';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import Link from 'next/link';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

export default function Footer() {
  const { isDesktop } = useMediaQueries();
  const { t } = useTranslation();
  const router = useRouter();
  const { asPath } = router;
  const phoneInfo = useMemo(() => {
    if (
      asPath === '/stores/ristoranti/ristorante-momento-neapolis' ||
      asPath ===
        '/stores/ristoranti/caffetteria-momento-neapolis' ||
      asPath === '/stores/ristoranti/ristorante-degli-scavi'
    ) {
      return {
        email: 'info@momentofood.it',
        phone: '345-4310103',
      };
    }

    if (
      asPath === '/stores/ristoranti/caffetteria-belvedere-taormina'
    ) {
      return {
        email: 'info@momentofood.it',
        phone: '345-6573468',
      };
    }

    if (asPath === '/stores/eventi/villa-mon-repos') {
      return {
        email: 'info@momentofood.it',
        phone: '334-9117892',
      };
    }

    return null;
  }, [asPath]);

  return (
    <footer
      id="footer"
      className={classnames(
        'footer',
        'h-[40rem] xl:h-[40rem] z-10',
        'fixed bottom-0 left-0 right-0',
        'border-t-4 border-primary-500',
      )}
    >
      <div className="max-w-6xl px-4 py-12 mx-auto space-y-8 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center space-y-4">
          <Logo className="w-10 h-10 fill-primary-500" />
          <MomentoLogo className="w-40 h-auto fill-neutral" />

          <div className="flex flex-col items-center py-6">
            <span className="text-xl label text-neutral">
              {t('labels.slogan.genuine_ingredients')}
            </span>
            <span className="label text-neutral">
              {t('labels.slogan.special_moments')}
            </span>
          </div>
          <SwitchLocale className="justify-center" dark={true} />
          <div className="flex justify-center">
            <div className="w-10 flex justify-center">
              <a
                target="_blank"
                href="https://www.facebook.com/momentofoodit"
              >
                <span className="sr-only">Facebook</span>
                <FacebookIcon className="fill-neutral" />
              </a>
            </div>
            <div className="w-10  flex justify-center">
              <a
                target="_blank"
                href="https://www.instagram.com/momentofoodit"
              >
                <span className="sr-only">Instagram</span>
                <InstagramIcon className="fill-neutral" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center text-neutral text-lg label mb-8">
        <p>{t('labels.info_booking')}:</p>
        {phoneInfo ? (
          <p className="space-x-2">
            <a href={`mailto:${phoneInfo.email}`}>
              {phoneInfo.email}
            </a>{' '}
            <span className="pb-1">|</span>{' '}
            <a href={`tel:${phoneInfo.phone.replace(/-/g, '')}`}>
              tel. {phoneInfo.phone}
            </a>
          </p>
        ) : (
          <div className="text-center leading-relaxed">
            <div>
              <a href={`mailto:info@momentofood.it`}>
                info@momentofood.it
              </a>
            </div>
            <br />
            <div>
              Siracusa e Ostia Antica:{' '}
              <a href={`tel:+393454310103`}>345 4310103</a>
              <br />
              Caffetteria Belvedere Taormina:{' '}
              <a href={`tel:+393456573468`}>345 6573468</a>
              <br />
              Villa Mon Repos Taormina:{' '}
              <a href={`tel:+393349117892`}>334 9117892</a>
            </div>
          </div>
        )}
      </div>
      <div className="address flex items-center justify-center">
        <span className="text-neutral/50">
          CF/P.IVA 01973370545
        </span>
      </div>

      <div
        className={classnames(
          'h-18  absolute bottom-0 w-full space-x-2 bg-[#1b1b1b]',
          'flex flex-col justify-center items-center',
          'text-sm',
        )}
      >
        <span className="text-neutral label">
          © Copyright {new Date().getFullYear()} by
        </span>
        <Link
          href="/"
          className="transition-colors duration-500 ease-in-out hover:text-primary-300"
        >
          <MomentoLogo className={'fill-primary h-4'} />
        </Link>
      </div>
    </footer>
  );
}
